import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
// Types

import { getFeatureFlag } from '@white-label-plugin/launch-darkly';
import { DEDICATED_WL_ROUTES_PATH } from '@white-label-configuration/constants';

/**
 * Ensures that the path is correctly formatted with a '/' between segments.
 * If only `basePath` is provided, it will return ending with a '/'
 * (same applies for `subPath`).
 * @param basePath (Optional) The base path
 * @param subPath (Optional) The sub path to append
 * @returns A properly formatted path
 */
export function normalisePath() {
  var basePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var subPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var normalizedBase = basePath.endsWith('/') ? basePath : "".concat(basePath, "/");
  var normalizedSub = subPath.startsWith('/') ? subPath.slice(1) : subPath;
  return normalizedBase + normalizedSub;
}

/**
 * Pushes to the router with the correct path, considering dedicated booking flow.
 * This function ensures that the navigation respects feature flags and appends paths correctly.
 * Example usage:
 *   pushToRouter(routerInstance, { path: '/home', query: { id: 123 } });
 *
 * @param options Router push options, including:
 *   - path: The target path to navigate to (e.g., '/home').
 *   - query: Optional query parameters (e.g., { id: 123 }).
 */
export var pushToRouter = function pushToRouter(options) {
  var _nuxtApp$$route, _options$query;
  // @ts-expect-error - until we have defined global types for nuxtApp
  var nuxtApp = useNuxtApp();
  var currentRoutePath = nuxtApp === null || nuxtApp === void 0 ? void 0 : (_nuxtApp$$route = nuxtApp.$route) === null || _nuxtApp$$route === void 0 ? void 0 : _nuxtApp$$route.path;
  var pathname = options.path;

  /**
   * https://magusa.atlassian.net/browse/CUS-2508
   * Adds support for dedicated wl /partner flow.
   * If the feature flag 'CUS_2533_DEDICATED_BOOKING_FLOW' is enabled and the current route
   * includes the dedicated WL routes path, the pathname is updated to include the base path.
   * Example:
   *   - Base path: '/partner'
   *   - Target path: '/booking'
   *   - Result: '/partner/booking'
   */
  if (getFeatureFlag('CUS_2533_DEDICATED_BOOKING_FLOW') && currentRoutePath.includes(DEDICATED_WL_ROUTES_PATH.INDEX)) {
    pathname = normalisePath(DEDICATED_WL_ROUTES_PATH.INDEX, pathname);
  }

  // Push the updated path and query parameters to the router.
  nuxtApp.$router.push({
    path: pathname,
    query: (_options$query = options.query) !== null && _options$query !== void 0 ? _options$query : {}
  });
};